@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/graphics-panel/clipping-studio-graphics-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar,
.graphics-panel__mam-list::-webkit-scrollbar,
.graphics-panel__grid::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar-button,
.graphics-panel__mam-list::-webkit-scrollbar-button,
.graphics-panel__grid::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar-corner,
.graphics-panel__mam-list::-webkit-scrollbar-corner,
.graphics-panel__grid::-webkit-scrollbar-corner {
  background: transparent;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar-thumb:hover,
.graphics-panel__mam-list::-webkit-scrollbar-thumb:hover,
.graphics-panel__grid::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar-thumb,
.graphics-panel__mam-list::-webkit-scrollbar-thumb,
.graphics-panel__grid::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar-thumb:hover,
.graphics-panel__mam-list::-webkit-scrollbar-thumb:hover,
.graphics-panel__grid::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar-track:hover,
.graphics-panel__mam-list::-webkit-scrollbar-track:hover,
.graphics-panel__grid::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.graphics-panel__mam-editor-body::-webkit-scrollbar-track,
.graphics-panel__mam-list::-webkit-scrollbar-track,
.graphics-panel__grid::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.graphics-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.graphics-panel__tabs {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  flex-shrink: 0;
}
.graphics-panel__tab {
  flex: 1;
  padding: 12px 8px;
  font-size: 13px;
  font-weight: 700;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
}
.graphics-panel__tab:hover {
  color: rgba(0, 0, 0, 0.85);
}
.graphics-panel__tab--active {
  border-bottom-color: rgb(45, 187, 252);
  color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.06);
}
.graphics-panel__mam-filter {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  padding: 0 12px;
  flex-wrap: wrap;
}
.graphics-panel__filter-btn {
  padding: 6px 12px;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  border-radius: 6px;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;
}
.graphics-panel__filter-btn:hover {
  color: rgba(0, 0, 0, 0.85);
  background: rgba(0, 0, 0, 0.04);
}
.graphics-panel__filter-btn.active {
  color: rgb(45, 187, 252);
  border-color: rgb(45, 187, 252);
  background: transparent;
}
.graphics-panel__header {
  padding: 10px 12px;
  flex-shrink: 0;
}
.graphics-panel__search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}
.graphics-panel__search-wrapper ichannel-input {
  flex: 1;
}
.graphics-panel__search-wrapper ::ng-deep ichannel-input input {
  border-radius: 6px;
}
.graphics-panel__search-wrapper ::ng-deep ichannel-input > div.rowInput,
.graphics-panel__search-wrapper ::ng-deep ichannel-input > div {
  margin-bottom: 0;
}
.graphics-panel__search-clear {
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.graphics-panel__search-clear:hover {
  color: rgba(0, 0, 0, 0.85);
}
.graphics-panel__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 12px;
}
.graphics-panel__error {
  padding: 12px 0;
}
.graphics-panel__error-text {
  margin: 0;
  font-size: 14px;
  color: #ef5350;
}
.graphics-panel__message {
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  padding: 0 12px;
}
.graphics-panel__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  padding: 0 16px 20px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  align-content: start;
}
.graphics-panel__grid > * {
  min-width: 0;
}
.graphics-panel__mam-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 12px 20px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.graphics-panel__mam-list > * {
  min-width: 0;
}
.graphics-panel__mam-template {
  cursor: pointer;
}
.graphics-panel__instances-container {
  display: none;
  margin: 8px 0 12px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
}
.graphics-panel__instances-container.show {
  display: block;
}
.graphics-panel__instances-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}
.graphics-panel__instances-header button {
  border: none;
  background: transparent;
  color: rgb(45, 187, 252);
  font-size: 11px;
  cursor: pointer;
  padding: 0;
}
.graphics-panel__instances-list {
  padding: 0 6px 8px;
}
.graphics-panel__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.graphics-panel__empty-text {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.graphics-panel__mam-editor {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  z-index: 20;
  font-family: "Open Sans", sans-serif;
}
.graphics-panel__mam-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}
.graphics-panel__mam-editor-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  font-family: "Open Sans", sans-serif;
}
.graphics-panel__mam-editor-close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.graphics-panel__mam-editor-close-btn:hover {
  color: rgba(0, 0, 0, 0.85);
}
.graphics-panel__mam-editor-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  background-color: rgb(255, 255, 255);
}
.graphics-panel__mam-editor-fields {
  padding: 15px 16px 24px;
  min-width: 0;
}
.graphics-panel__mam-editor-message {
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.graphics-panel__mam-editor-error {
  margin: 0;
  font-size: 14px;
  color: #ef5350;
}
.graphics-panel__mam-editor-footer {
  padding: 12px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.graphics-panel__mam-editor-add-btn {
  width: 100%;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  border: none;
  border-radius: 6px;
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  transition: background 0.15s ease, opacity 0.15s ease;
}
.graphics-panel__mam-editor-add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.graphics-panel__mam-editor-add-btn:hover:not(:disabled) {
  background: rgb(41, 170, 229);
}
.graphics-panel__mam-editor-cancel-btn {
  width: 100%;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 6px;
  border: 1px solid rgba(45, 187, 252, 0.5);
  background: rgb(255, 255, 255);
  color: rgb(45, 187, 252);
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
}
.graphics-panel__mam-editor-cancel-btn:hover {
  background: rgb(233, 248, 255);
}
/*# sourceMappingURL=clipping-studio-graphics-panel.component.css.map */
